/**
 * Controls the visual behavior of the ContactForm
 *
 * @type {ContactFormHelper}
 */
export class ContactFormHelper {
    constructor() {
        this.doms = document.querySelectorAll('.js__textarea-auto-resize > textarea')
        this.init()
    }

    /**
     * Initialize the module
     */
    init() {
        if (this.doms.length >= 1) {
            this.addAutoResizeOnTextAreaTag()
        }
    }

    /**
     * addAutoResizeOnTextAreaTag
     */
    addAutoResizeOnTextAreaTag() {
        this.doms.forEach(function (element) {
            element.style.boxSizing = 'border-box'
            var offset = element.offsetHeight - element.clientHeight

            // Initial height (depending on the placeholder text length)
            element.style.height = element.scrollHeight + offset + 'px'

            // Dynamic height (when windos is resized)
            window.addEventListener('resize', () => {
                element.style.height = 'auto' // Reset to auto height, for re-calculating the height at next line.
                element.style.height = element.scrollHeight + offset + 'px'
            })

            // Dynamic height (when input is triggered every time)
            element.addEventListener('input', function (event) {
                event.target.style.height = 'auto' // Reset to auto height, for re-calculating the height at next line.
                event.target.style.height = event.target.scrollHeight + offset + 'px'
            })
        })
    }
}
